import { render, staticRenderFns } from "./SalesUserLevelList.vue?vue&type=template&id=56856376&scoped=true&"
import script from "./SalesUserLevelList.vue?vue&type=script&lang=js&"
export * from "./SalesUserLevelList.vue?vue&type=script&lang=js&"
import style0 from "./SalesUserLevelList.vue?vue&type=style&index=0&id=56856376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56856376",
  null
  
)

export default component.exports